import { TableCustomiseOptions, QuickLookOptions, SelectionConfig } from '../../../elements/leaderboard/types';
import {
  CollectionOptions,
  ContentInstructions,
  CoreContents,
  ExportOptions,
  FromSettingsInstruction,
} from '../../../types';
import { DataOptionsFactory } from '../data';
import { ContentFactory } from './base';

export type LeaderboardOptions = {
  /**  provide options for how to fetch or receive data */
  data?: DataOptionsFactory;
  /** how to identify rows */
  rowIdField: string | FromSettingsInstruction;
  quickLookOptions?: {
    titleField: string;
    preTitleField?: string;
    contents: ContentFactory[];
  };
  exportOptions?: ExportOptions;
  collectionOptions?: CollectionOptions;
  selectionConfig?: SelectionConfig;
  customiseOptions?: TableCustomiseOptions;
  preferencesGroupName: string;
  groupsParam: string;
};
export class LeaderboardFactory extends ContentFactory {
  constructor(options: LeaderboardOptions) {
    const {
      data,
      rowIdField,
      quickLookOptions,
      selectionConfig,
      customiseOptions,
      exportOptions,
      collectionOptions,
      preferencesGroupName,
      groupsParam,
    } = options;

    let quickLook: QuickLookOptions | undefined;
    if (quickLookOptions) {
      quickLook = {
        contents: quickLookOptions.contents.map(c => c._build()),
        titleField: quickLookOptions.titleField,
        preTitleField: quickLookOptions.preTitleField,
      };
    }

    const instructions: ContentInstructions = {
      rowIdField:
        typeof rowIdField === 'string'
          ? {
              type: 'StringInstruction',
              instruction: rowIdField,
            }
          : rowIdField,
    };

    instructions.preferencesGroupName = {
      type: 'StringInstruction',
      instruction: preferencesGroupName,
    };

    instructions.groupsParam = {
      type: 'StringInstruction',
      instruction: groupsParam,
    };

    if (quickLook) {
      instructions.quickLook = {
        type: 'ObjectInstruction',
        instruction: quickLook,
      };
    }

    if (selectionConfig) {
      instructions.selectionConfig = {
        type: 'ObjectInstruction',
        instruction: selectionConfig,
      };
    }

    if (customiseOptions) {
      instructions.customiseOptions = {
        type: 'ObjectInstruction',
        instruction: customiseOptions,
      };
    }

    if (exportOptions) {
      instructions.export = {
        type: 'ObjectInstruction',
        instruction: exportOptions,
      };
    }

    if (collectionOptions) {
      instructions.collection = {
        type: 'ObjectInstruction',
        instruction: collectionOptions,
      };
    }
    super(CoreContents.leaderBoard, {
      data: data || DataOptionsFactory.asReceiver(),
      instructions,
    });
  }
}
